export default [
    "24 24",
    '<rect y="0.5" width="5.0002" height="5.0002" fill="var(--ci-primary-color, currentColor)"/>\n' +
    '<rect x="4.99951" y="5.5" width="5.0002" height="5.0002" fill="var(--ci-primary-color, currentColor)"/>\n' +
    '<rect x="10" y="5.5" width="5.0002" height="5.0002" fill="var(--ci-primary-color, currentColor)"/>\n' +
    '<rect x="10" y="10.5" width="5.0002" height="5.0002" fill="var(--ci-primary-color, currentColor)"/>\n' +
    '<rect y="10.5" width="5.0002" height="5.0002" fill="var(--ci-primary-color, currentColor)"/>']

